var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9975 9.16667C12.9975 7.55583 11.6916 6.25 10.0808 6.25C8.46996 6.25 7.16412 7.55583 7.16412 9.16667C7.16412 10.7775 8.46996 12.0833 10.0808 12.0833C11.6916 12.0833 12.9975 10.7775 12.9975 9.16667Z",
    stroke: "#00A63E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9831 9.45825C13.2514 9.53958 13.536 9.58333 13.8308 9.58333C15.4417 9.58333 16.7475 8.2775 16.7475 6.66667C16.7475 5.05583 15.4417 3.75 13.8308 3.75C12.3184 3.75 11.0748 4.90117 10.9286 6.37511",
    stroke: "#00A63E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23304 6.37511C9.08679 4.90117 7.84322 3.75 6.33079 3.75C4.71996 3.75 3.41412 5.05583 3.41412 6.66667C3.41412 8.2775 4.71996 9.58333 6.33079 9.58333C6.62563 9.58333 6.91025 9.53958 7.17852 9.45825",
    stroke: "#00A63E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4141 13.75C18.4141 11.4488 16.3621 9.58333 13.8308 9.58333",
    stroke: "#00A63E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6642 16.25C14.6642 13.9488 12.6122 12.0833 10.0808 12.0833C7.54952 12.0833 5.4975 13.9488 5.4975 16.25",
    stroke: "#00A63E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33083 9.58333C3.79952 9.58333 1.7475 11.4488 1.7475 13.75",
    stroke: "#00A63E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersGreen);
export default __webpack_public_path__ + "static/media/users-green.93948b48494759bea14987b4e51b5d3d.svg";
export { ForwardRef as ReactComponent };